export default __webpack_public_path__ + "static/media/html.eaa80376.svg";